/* eslint-disable no-empty */
import React, { Dispatch, FC, SetStateAction, useEffect, useRef, useState } from "react";
import { chakra } from "@chakra-ui/react";
import cn from "classnames";
import { observer } from "mobx-react-lite";
import GiveTheThumbsUp from "@/pages/Gallery/components/GiveTheThumbsUp";
import { GalleryItemType } from "@/stores/gallery";
import styles from "./index.module.scss";
import Album, { AlbumData } from "@/pages/Gallery/components/Album";
import config from "@/config";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import ColorThief from "colorthief";
import { loginStore } from "@/modules/login/store";
const colorThief = new ColorThief();
interface GalleryItemProps {
  setCurrent: Dispatch<SetStateAction<number>>;
  data: any;
  setDetailVisible: Dispatch<SetStateAction<boolean>>;
  list: GalleryItemType[];
  onAlbum: (type: 1 | 2 | 3, albumData: AlbumData) => void;
  onLike?: (image_id: number) => void;
  onCancelLike?: (image_id: number) => void;
}
const GalleryItem: FC<GalleryItemProps> = (props) => {
  const { setCurrent, data, setDetailVisible, list, onAlbum, onLike, onCancelLike } = props;
  const imgRef = useRef<HTMLImageElement>(null);
  const loadingTimes = useRef<number>(0);
  const wrapperRef = useRef<HTMLAnchorElement | null>(null);
  const falsificationRef = useRef<HTMLDivElement>(null);
  const [boxShadow, setBoxShadow] = useState<string>("");
  const [dominantBoxShadow, setDominantBoxShadow] = useState<string>("");
  useEffect(() => {
    falsificationRef.current && (falsificationRef.current.style.display = "flex");
    setTimeout(() => {
      falsificationRef.current && (falsificationRef.current.style.display = "none");
    }, 2000);
  }, [data.photo.src]);
  return (
    <a
      ref={wrapperRef}
      // href={`${location.origin}/arts/${data.photo.key}`}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        //修改url，但不跳转
        setCurrent(Number(data.photo.key));
        history.pushState(null, "", `${location.origin}/arts/${data.photo.key}`);
        setDetailVisible(true);
      }}
      onMouseEnter={() => {
        setDominantBoxShadow(boxShadow);
      }}
      onMouseLeave={() => {
        setDominantBoxShadow("");
      }}
      data-imageid={data.photo.key}
      className={cn(styles.galleryItem)}
      style={{
        width: data?.photo?.width,
        height: data?.photo?.height,
        left: data.left,
        top: data.top,
        boxShadow: dominantBoxShadow ? dominantBoxShadow : "",
      }}
    >
      <chakra.a href={`${location.origin}/arts/${data.photo.key}`} pos="absolute" zIndex={-100} />
      <img
        src={
          data.photo.src
            ? `${data.photo.src}?x-oss-process=image/resize,w_350/format,jpg/interlace,1`
            : ""
        }
        alt={data.photo.original}
        className={styles.preview}
        ref={imgRef}
        onLoad={(ref) => {
          falsificationRef.current && (falsificationRef.current.style.display = "none");
          try {
            imgRef.current && (imgRef.current.crossOrigin = "Anonymous");
            let dominantColor = colorThief.getColor(ref.target);
            dominantColor = `rgba(${dominantColor[0]},${dominantColor[1]},${dominantColor[2]},0.25) 0 64px 64px 0,rgba(${dominantColor[0]},${dominantColor[1]},${dominantColor[2]},0.25) 0 32px 32px 0,rgba(${dominantColor[0]},${dominantColor[1]},${dominantColor[2]},0.25) 0 16px 16px 0,rgba(${dominantColor[0]},${dominantColor[1]},${dominantColor[2]},0.25) 0 8px 8px 0,rgba(${dominantColor[0]},${dominantColor[1]},${dominantColor[2]},0.25) 0 4px 4px 0`;
            setBoxShadow(dominantColor);
            // eslint-disable-next-line no-empty, prettier/prettier
          } catch (e) {}
        }}
        onError={(node: any) => {
          if (loadingTimes.current < 2) {
            node.target.src = `${data.photo.src}?x-oss-process=image/resize,w_350`;
            loadingTimes.current = loadingTimes.current + 1;
          } else {
            if (wrapperRef.current) {
              wrapperRef.current.style.border = "1px solid #2a2a2a";
              wrapperRef.current.style.justifyContent = "center";
              wrapperRef.current.style.alignItems = "center";
              wrapperRef.current.style.display = "flex";
            }
            node.target.style.maxWidth = "100%";
            node.target.style.maxHeight = "100%";
            node.target.style.height = "fit-content";
            node.target.style.width = "fit-content";
            node.target.src = `${config.buildCdnBaseUrl}assets/creator/galleryItemError.png`;
            falsificationRef.current && (falsificationRef.current.style.display = "none");
          }
        }}
      />
      <div className={styles.falsification} ref={falsificationRef}>
        <img src={`${config.buildCdnBaseUrl}assets/creator/gallery-item-loading.gif`} alt="" />
      </div>
      <div className={styles.information}>
        <div
          className={styles.leftWrapper}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            window.open(`/artists/${data.photo?.user?.user_id}`, "_blank");
          }}
        >
          {data?.photo?.user?.avatar && data?.photo?.user?.nickname && (
            <>
              <img
                src={
                  data?.photo?.user?.avatar
                    ? `${data?.photo?.user?.avatar}?x-oss-process=image/resize,w_48`
                    : ""
                }
                alt=""
              />
              <span className={styles.name}>{data?.photo?.user?.nickname}</span>
            </>
          )}
        </div>
        <GiveTheThumbsUp
          image_id={parseInt(data.photo.key as string)}
          likes={data?.photo?.likes}
          is_like={data?.photo?.is_like}
          onLike={onLike}
          onCancelLike={onCancelLike}
        />
      </div>
      <Album
        is_gallery={true}
        albumData={{
          image_id: data.photo.key,
          album_id: data.photo.album_id,
          album_image_id: data.photo.album_image_id,
          album_name: data.photo.album_name,
          is_album: data.photo.is_album,
          meta_json: data.photo.meta_json,
          image_url: data.photo.src,
        }}
        onAlbum={onAlbum}
      />
    </a>
  );
};
export default observer(GalleryItem);
